import {
  Component,
  ElementRef,
  Input,
  OnInit,
  Renderer2,
  ViewChild,
  ViewEncapsulation,
} from "@angular/core";
import { Router } from "@angular/router";
import { Store } from "@ngrx/store";
import { AppState, stateGetter } from "src/app/store/state/app.state";
import { GlobalHeaderDataService } from "../global-header-data.service";
import { FormControl } from "@angular/forms";
import { debounceTime } from "rxjs/operators";
import {
  faSearch,
  faTimes,
  faChevronRight,
} from "@fortawesome/pro-light-svg-icons";
import { Subscription } from "rxjs";
import {
  VAIconRegistryService,
  close,
  search,
  chevronRight,
} from "@va/core-library/icons";

import { ResetSectorIndustryData } from "src/app/store/actions/sector-industry.actions";
import { AppService } from "src/app/app.service";

@Component({
  selector: "app-global-search",
  templateUrl: "./global-search.component.html",
  styleUrls: ["./global-search.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class GlobalSearchComponent implements OnInit {
  myControl = new FormControl("");
  searchQuery: string;

  @Input() recentlyVisitedCompanies = [];
  // TO-DO: send escapeliteral to a common util section
  escapeliteral = "{fslash}"; // literal used to escape tickers having '/' in their name
  globalSearchShow = false;
  searchResult: any[] = [];
  priorityList = [
    "Company",
    "Industry Comp Tables",
    // "Sector",
    "Industry",
    "Analyst",
    "Broker",
  ];
  companySmallColSize = 10;
  companyLargeColSize = 10;
  categoryColSize = 3;
  searchResultTotal = 0;
  selectedGlobalSearchRow = 0;
  showMore = false;
  isServerError = true;
  isOpen = false;
  activeIndex: number = 0;
  /* Keeping below flags true by default in order to avoid showing respective links 
    to user in case get_user_default_data call fails
  */
  isSellSide = true;
  isModelsOnlyUser = true;
  // ---- end ---
  alertMsg: string;
  prevInput = "";
  faSearch = faSearch;
  faTimes = faTimes;
  faChevronRight = faChevronRight;
  legacyUrl = `${window.caUrl}/app`;
  legacyDomain = window.caUrl;
  isSearchResultLoading = false;
  showClearIcon = false;
  splitView = false;
  resultHeader: "RECENTLY VIEWED" | "Results";
  schResult: Subscription;
  // Adding input as a FormControl so that we can use the valueChanges method
  queryField: FormControl = new FormControl();
  inputSearchQuery = "";
  prevInputSearchQuery = "";
  searchMenu: any;
  selectedTabIndex: number = 0;
  matchQueryString = "";
  activeIndexes: number[] = [0, 0, 0, 0, 0, 0]; // Initialize with 0 for each tab

  companyExists = false;
  @ViewChild("searchInput") searchInput: ElementRef;
  /**
   * Class representing a global search component.
   */
  constructor(
    private dataService: GlobalHeaderDataService,
    private renderer: Renderer2,
    private store: Store<AppState>,
    private router: Router,
    private iconRegistry: VAIconRegistryService,
    private appService: AppService,
  ) {
    router.events.subscribe(() => {
      this.queryField.reset();
    });
    this.iconRegistry.registerIcons([close, search, chevronRight]);
  }
  /**
   * Binds events for search bar.
   * @constructor
   */
  ngOnInit(): void {
    // Debounce seems to work better with an Observable returned like this, rathe than an onKeyup written on the <input/>
    this.queryField.valueChanges.pipe(debounceTime(500)).subscribe((text) => {
      if (text !== "" && text !== null) {
        this.showClearIcon = true;
        this.isOpen = true;
        this.globalSearchTypeNFetch(text);
      } else {
        this.showClearIcon = false;
      }
    });
    this.store
      .select(stateGetter("globalHeader", "globalSettings"))
      .subscribe((data: any) => {
        this.isSellSide = data.isSellside;
        this.isModelsOnlyUser = data.isModelsOnlyUser;
      });
    // TODO: Might have to add stricter element checks to prevent closing when clicked inside
    // this.renderer.listen("window", "click", (e) => {
    //   if (e.target.id !== "globalSearch") {
    //     this.globalSearchShow = false;
    //     this.clearSearch();
    //   }
    // });
    this.router.events.subscribe(() => {
      this.closeSearch();
      this.onBackdropClick();
    });
  }

  onBackdropClick() {
    this.isOpen = false;
    this.inputSearchQuery = "";
    this.prevInputSearchQuery = "";
    this.selectedTabIndex = 0;
    this.activeIndex = 0;
  }
  toggleOverlay() {
    this.isOpen = !this.isOpen;
    const fieldVal = this.queryField.value;
    if (fieldVal === "" || fieldVal === null) {
      this.searchResultTotal = this.recentlyVisitedCompanies.length;
      this.selectedGlobalSearchRow = 0;
      this.globalSearchShow = true;
      this.splitView = true;
    }
  }
  onInputChange(value: string) {
    this.prevInputSearchQuery = value;
  }

  scrollToActive(tabIndex, isFromTabs) {
    let list = null;
    if (!isFromTabs) {
      list = document.getElementById("recentList");
    } else if (isFromTabs) {
      switch (tabIndex) {
        case 0:
          list = document.getElementById("all");
          break;
        case 1:
          list = document.getElementById("company");
          break;
        case 2:
          list = document.getElementById("industry");
          break;
        case 3:
          list = document.getElementById("industryComp");
          break;
        case 4:
          list = document.getElementById("analyst");
          break;
        case 5:
          list = document.getElementById("brokers");
          break;
        default:
          break;
      }
    }
    if (list) {
      const activeItem = list.querySelector(".active");
      if (activeItem) {
        activeItem.scrollIntoView({ behavior: "smooth", block: "center" });
      }
    }
  }

  onArrowUp(event: KeyboardEvent, tabIndex: number) {
    event.preventDefault();
    if (this.queryField.value.length === 0) {
      this.activeIndex = Math.max(0, this.activeIndex - 1);
    } else if (this.queryField.value.length > 0) {
      switch (tabIndex) {
        case 0:
          this.activeIndexes[tabIndex] = Math.max(
            0,
            this.activeIndexes[tabIndex] - 1,
          );
          break;
        case 1:
          this.activeIndexes[tabIndex] = Math.max(
            0,
            this.activeIndexes[tabIndex] - 1,
          );
          break;
        case 2:
          this.activeIndexes[tabIndex] = Math.max(
            0,
            this.activeIndexes[tabIndex] - 1,
          );
          break;
        case 3:
          this.activeIndexes[tabIndex] = Math.max(
            0,
            this.activeIndexes[tabIndex] - 1,
          );
          break;
        case 4:
          this.activeIndexes[tabIndex] = Math.max(
            0,
            this.activeIndexes[tabIndex] - 1,
          );
          break;
        case 5:
          this.activeIndexes[tabIndex] = Math.max(
            0,
            this.activeIndexes[tabIndex] - 1,
          );
          break;
        default:
          break;
      }
    }
    this.scrollToActive(tabIndex, this.queryField.value.length);
  }

  onArrowDown(event: KeyboardEvent, tabIndex: number) {
    event.preventDefault();
    if (this.queryField.value.length === 0) {
      this.activeIndex = Math.min(
        this.recentlyVisitedCompanies.length - 1,
        this.activeIndex + 1,
      );
    } else if (this.queryField.value.length > 0) {
      switch (tabIndex) {
        case 0:
          this.activeIndexes[tabIndex] = Math.min(
            this.searchResult["All_Combined"].length - 1,
            this.activeIndexes[tabIndex] + 1,
          );
          break;
        case 1:
          this.activeIndexes[tabIndex] = Math.min(
            this.searchResult["Company"].data.length - 1,
            this.activeIndexes[tabIndex] + 1,
          );
          break;
        case 2:
          this.activeIndexes[tabIndex] = Math.min(
            this.searchResult["Industry"].data.length - 1,
            this.activeIndexes[tabIndex] + 1,
          );
          break;
        case 3:
          this.activeIndexes[tabIndex] = Math.min(
            this.searchResult["Industry Comp Tables"].data.length - 1,
            this.activeIndexes[tabIndex] + 1,
          );
          break;
        case 4:
          this.activeIndexes[tabIndex] = Math.min(
            this.searchResult["Analyst"].data.length - 1,
            this.activeIndexes[tabIndex] + 1,
          );
          break;
        case 5:
          this.activeIndexes[tabIndex] = Math.min(
            this.searchResult["Broker"].data.length - 1,
            this.activeIndexes[tabIndex] + 1,
          );
          break;
        default:
          break;
      }
    }
    this.scrollToActive(tabIndex, this.queryField.value.length);
  }

  onTabChange(event) {
    this.activeIndexes[event] = 0;
    this.selectedTabIndex = event;
    this.inputSearchQuery = this.prevInputSearchQuery;
  }

  onSearchClick() {
    this.isOpen = true;
  }

  closeSearch(): void {
    this.globalSearchShow = false;
    this.clearSearch();
    // this.onBackdropClick();
  }
  clearSearch(): void {
    this.queryField.setValue("");
  }

  searchPanelClosed() {
    this.queryField.setValue("");
  }

  globalSearchTypeNFetch = (text: string): void => {
    this.matchQueryString = text;
    this.globalSearchShow = true;
    this.isSearchResultLoading = true;
    if (this.schResult) {
      this.schResult.unsubscribe();
    }
    this.schResult = this.dataService
      .getGlobalSearchData(text)
      .subscribe((respObject: any) => {
        this.searchResult = [];
        this.searchResultTotal = 0;
        this.isSearchResultLoading = false;
        if (respObject.status !== "failure" && this.globalSearchShow === true) {
          let tabIndex = 0;
          // this.resultHeader = "Results";
          this.splitView = false;
          this.searchResult = respObject.srhData;
          this.searchResult["All_Combined"] = [];
          if (
            respObject.srhData &&
            respObject.srhData["All"] &&
            respObject.srhData["All"].data
          ) {
            Object.keys(respObject.srhData["All"].data).forEach((category) => {
              respObject.srhData["All"].data[category].forEach((item) => {
                this.searchResult["All_Combined"].push({
                  ...item,
                  all_category: category,
                });
              });
            });
          }
          if (
            this.searchResult &&
            this.searchResult["Company"] &&
            this.searchResult["Company"].data.length
          ) {
            this.companyExists = true;
            this.companySmallColSize = 10;
            this.companyLargeColSize = 10;
            this.categoryColSize = 3;
          } else {
            this.companyExists = false;
            this.companySmallColSize = 20;
            this.companyLargeColSize = 20;
            this.categoryColSize = 4;
          }

          for (const priorityItem of this.priorityList) {
            const currentVal = this.searchResult[priorityItem];
            if (!currentVal) {
              continue;
            }
            for (const sResult of currentVal.data) {
              this.searchResultTotal++;
              sResult.tabIndex = tabIndex;
              tabIndex++;
            }
          }
          this.globalSearchShow = true;
          this.selectedGlobalSearchRow = 0;
        } else {
          this.isServerError = true;
          this.alertMsg = respObject.msg;
          this.prevInput = "";
        }
      });
  };

  getCompanyLink(shortName) {
    let escapedTicker = "";
    if (shortName && shortName.indexOf("/") !== -1) {
      escapedTicker = shortName.replace("/", this.escapeliteral);
      escapedTicker = encodeURIComponent(escapedTicker);
    } else {
      escapedTicker = encodeURIComponent(shortName);
    }
    return `company/${escapedTicker}`;
  }

  getBrokerLink(shortName) {
    let escapedTicker = "";
    if (shortName.indexOf("/") !== -1) {
      escapedTicker = shortName.replace("/", this.escapeliteral);
      escapedTicker = encodeURIComponent(escapedTicker);
    } else {
      escapedTicker = encodeURIComponent(shortName);
    }
    return `reporting/broker/${escapedTicker}`;
  }

  globalSearchKeyActions = (type: string): void => {
    switch (type) {
      case "right": {
        this.selectedTabIndex++;
        this.selectedTabIndex = Math.abs(this.selectedTabIndex % 6);
        break;
      }
      case "left": {
        if (this.selectedTabIndex === 0) {
          this.selectedTabIndex = 5;
        } else {
          this.selectedTabIndex--;
          this.selectedTabIndex = Math.abs(this.selectedTabIndex % 6);
        }
        break;
      }
      case "enter": {
        const selectedLink: any = document.querySelectorAll(".active a")[0];
        if (selectedLink) {
          selectedLink.click();
        }
        break;
      }
      default:
    }
  };

  ngOnDestroy() {
    if (this.schResult) this.schResult.unsubscribe();
  }

  handleIndustryClick(industry) {
    this.store.dispatch(
      new ResetSectorIndustryData({
        reset: true,
      }),
    );
    this.onSearchResultClicked("industry", industry.n, industry.industryid);
  }

  onSearchResultClicked(type, value, id) {
    if (type && value && id && this.searchResult.length !== 0) {
      this.appService.logUserAction(
        {},
        "",
        "",
        "GLOBAL_SEARCH_SELECT",
        {
          name: type,
          value: value,
          id: id,
        },
        "",
        "GLOBAL_SEARCH",
      );
      // this.searchResult = [];
      this.searchResult = [];
    }
  }
}
